import { type ReactNode } from "react";

import {
  ResultsNextArrow,
  ResultsPrevArrow,
} from "@/components/common/ResultsSliderBase/ResultsArrows";
import { ResultsProvider } from "@/components/common/ResultsSliderBase/ResultsContext";
import { ResultsCounter } from "@/components/common/ResultsSliderBase/ResultsCounter";
import { ResultsResultsSlider } from "@/components/common/ResultsSliderBase/ResultsSlider";
import { ResultsSliderEmbla } from "@/components/common/ResultsSliderBase/ResultsSliderEmbla";
import { ResultsThumbnail } from "@/components/common/ResultsSliderBase/ResultsThumbnail";
import { ResultsThumbnailSlider } from "@/components/common/ResultsSliderBase/ResultsThumbnailSlider";
import { cn } from "@/utils/general";

type ResultsRootProps = {
  children: ReactNode;
  slidesCount: number;
  autoplay?: boolean;
  className?: string;
  track?: (payload: { index: number; interaction: string }) => void;
};

function ResultsRoot({
  children,
  slidesCount,
  autoplay = false,
  className,
  track,
}: ResultsRootProps) {
  return (
    <ResultsProvider slidesCount={slidesCount} autoplay={autoplay} track={track}>
      <section className={cn("w-full", className)}>{children}</section>
    </ResultsProvider>
  );
}

ResultsRoot.ResultsSlider = ResultsResultsSlider;
ResultsRoot.SliderEmbla = ResultsSliderEmbla;
ResultsRoot.ThumbnailSlider = ResultsThumbnailSlider;
ResultsRoot.Thumbnail = ResultsThumbnail;
ResultsRoot.Counter = ResultsCounter;
ResultsRoot.PrevArrow = ResultsPrevArrow;
ResultsRoot.NextArrow = ResultsNextArrow;

export const Results = Object.assign(ResultsRoot, {
  Root: ResultsRoot,
  ResultsSlider: ResultsResultsSlider,
  SliderEmbla: ResultsSliderEmbla,
  ThumbnailSlider: ResultsThumbnailSlider,
  Thumbnail: ResultsThumbnail,
  Counter: ResultsCounter,
  PrevArrow: ResultsPrevArrow,
  NextArrow: ResultsNextArrow,
});
